import { createFileRoute } from '@tanstack/react-router';
import { ManifestoListagem } from '@/features/mdfe/page/listagem/ManifestoListagem';

export const Route = createFileRoute('/a/manifesto-carga/')({
    component: ManifestoListagem,
});
